import { AppAreaConfig } from '@/funnels/@types'
import female from './female-al'
import male from './male-al'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-al',
	landing: {
		ids: ['loader-main'],
		route: {
			path: '/main-al',
			name: 'main-funnel-al',
		},
		overrides: [],
	},
	funnel: {
		id: 'ob-universal-funnel',
		route: {
			path: '/main-al/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'main-survey-al',
		},
		slug: 'main-al',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ja',
			'ar',
		],
		redirectTo: {
			sex: {
				male: { appArea: male },
				female: { appArea: female },
			},
		},
	},
}

export default appAreaConfig
